<div class="ia-copy-feedback-dialog" [formGroup]="formGroup">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="dialog-header">
        <h2>Share feedback</h2>
        <fa-icon class="close" (click)="close()" [icon]="['fas', 'times']"></fa-icon>
    </div>

    <p class="dialog-subtitle">Help us improve future copy. Your feedback is optional.</p>

    <mat-form-field appearance="outline" class="category-field" subscriptSizing="dynamic">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let option of feedbackCategories" [value]="option.value">
                {{ option.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="notes-field" subscriptSizing="dynamic">
        <mat-label>Feedback notes</mat-label>
        <textarea matInput rows="4" formControlName="notes"
            placeholder="Why didn't this copy work for you?"></textarea>
    </mat-form-field>

    <mat-card-actions fxLayout="row" [fxLayoutAlign]="showSkip ? 'space-between center' : 'end center'"
        class="dialog-actions">
        <button *ngIf="showSkip" mat-stroked-button type="button" (click)="skip()">Skip</button>
        <button mat-raised-button color="accent" type="button" (click)="submit()">{{ submitLabel }}</button>
    </mat-card-actions>
</div>
